import { Box, Button, CircularProgress, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Pagination, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material'
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { RootState } from '../../global/config/Reducer'
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice'
import { ArrowRightAlt, Download, MilitaryTechOutlined, NorthOutlined, ReportProblemOutlined, SouthOutlined, TaskOutlined, TrendingUpOutlined, VisibilityOutlined, WatchLaterOutlined } from '@mui/icons-material'
import ChecklistChart from '../../Components/Charts/ChecklistChart'
import { GoogleMap, InfoWindow, LoadScript, Marker } from '@react-google-maps/api'
import { ApiGetChecklistPdf, ApiGetChecklistSubmissionList, ApiGetClientChecklistDashboard, ApiGetAreaChecklistDashboard, ApiGetDashboardTodayChecklist, ApiGetVenueList } from '../../apiService/Core/Apicall'
import storage from '../../utils/storage'
import { toast } from 'react-toastify'
import redlocation from '../../assets/images/red-location.png'
import greenlocation from '../../assets/images/green-location.png'
import relativeTime from "dayjs/plugin/relativeTime";
import MixChart from '../../Components/Charts/MixChart'
import SubmittedChecklistList from './SubmittedChecklistList'
import VenueChecklistDashboard from '../New Checklist_V/VenueChecklistDashboard'
import store from '../../global/config/store'
import { hideLoading, showLoading } from '../../global/config/Reducer/loadingSlice'
import { RegionList } from '../../global/config/Reducer/RegionSlice'
import Domains from '../../global/constants/domain'
import Loading from '../../Components/Loader/Loading'

dayjs.extend(relativeTime);

function ClientChecklistDashboard() {
    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [month, setmonth] = useState<any>(dayjs(selectedMonth))
    const [dashboard, setDashboard] = useState<any>([])
    const navigate = useNavigate()
    const [checkListType, setCheckListType] = useState<string>(() => storage.getItem('dashboardCheckListType') || "BUSINESS")
    const userRole = storage.getItem('userRole');
    const [mapsApi, setMapsApi] = useState<any>(null);
    const mapRef = useRef<google.maps.Map | null>(null);
    const [selectedMarker, setSelectedMarker] = useState<any>(null);
    const [submittedChecklist, setSubmittedChecklist] = useState<any>([])
    const [value, setValue] = useState("all");
    const [todayTasklist, setTodayTasklist] = useState([]);
    const [venuelist, setvenuelist] = useState<any[]>([])
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity)
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | ''>(Regions[0]?.regionId ?? '')
    const isNotMM = "border"
    const [isLoading, setIsLoading] = useState<boolean>(false)



    const [pages, setPages] = useState<any>({}); // { cardKey: pageNumber }
    const rowsPerPage = 5;
    const getPage = (key: any) => pages[key] || 1;

    const setPage2 = (key: string, pageNum: number) => {
        setPages((prev: any) => ({ ...prev, [key]: pageNum }));
    };
    const getTotalPages = (key: string, dataArr: any, limit = rowsPerPage) => Math.ceil((dataArr?.length || 0) / limit);

    const getPaginatedData = (key: string, dataArr: any, limit = rowsPerPage) => {
        const currentPage = getPage(key);
        return (
            dataArr?.slice(
                (currentPage - 1) * limit,
                currentPage * limit
            ) || []
        );
    };



    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newValue: string | null
    ) => {
        if (newValue !== null) {
            setValue(newValue);
        }
    };

    useEffect(() => {
        setmonth(dayjs(selectedMonth))
    }, [selectedMonth])


    const GetSubmittedChecklistList = async () => {
        try {
            const areaId = storage.getItem('areaId');
            const areaIdParam = (areaId && areaId !== "undefined" && areaId !== "null") ? `&areaId=${areaId}` : '';
            const data = `?month=${month.month() + 1}&year=${month.year()}&clientEntityId=${storage.getItem('clientEntityId')}&offset=0&limit=5&status=SUBMITTED&isRecentNeeded=true${areaIdParam}&checkListType=${checkListType}`
            const res = await ApiGetChecklistSubmissionList(data)
            if (res?.status || res?.success) {
                setSubmittedChecklist(res?.data)
            }
        } catch (error: any) {
            toast.error(error)
        }

     }

    const GetDashboard = async () => {
        try {
            setIsLoading(true)
            const isAreaManager = checkListType === "AREA_MANAGER";
            const areaId = storage.getItem('areaId');
            const areaIdParam = (areaId && areaId !== "undefined" && areaId !== "null") ? `&areaId=${areaId}` : '';
            const data = `?month=${month.month() + 1}&year=${month.year()}&clientEntityId=${storage.getItem('clientEntityId')}${isAreaManager ? "" : "&type=business"}${areaIdParam}`
            const res = isAreaManager
                ? await ApiGetAreaChecklistDashboard(data)
                : await ApiGetClientChecklistDashboard(data);
            if (res?.status || res?.success) {
                setDashboard(res?.data)
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            setIsLoading(false)
        }

    }

    const GetTodaysChecklist = async () => {
        try {
            const data = `?type=${checkListType === "AREA_MANAGER" ? "area_manager" : "business"}&clientEntityId=${storage.getItem('clientEntityId')}&todayDate=${dayjs().format("YYYY-MM-DD")}&statuses=CREATED,DRAFT&includePrevious=true&checkListType=${checkListType}`
            const res = await ApiGetDashboardTodayChecklist(data)
            if (res?.status || res?.success) {
                const listData = Array.isArray(res?.data)
                    ? res.data
                    : (Array.isArray(res?.data?.list)
                        ? res.data.list
                        : (Array.isArray(res?.data?.data) ? res.data.data : []));
                setTodayTasklist(listData)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    useEffect(() => {
        if (storage.getItem('userRole') === "areaManager") {
            venuelist?.length > 0 && GetDashboard()
        }
        else {
            GetDashboard()
        }
        GetSubmittedChecklistList()
        GetTodaysChecklist()
    }, [venuelist, month, checkListType])

    const isAreaManager = checkListType === "AREA_MANAGER";
    const complianceMap = useMemo(() => {
        return isAreaManager ? dashboard?.areaComplianceMap : dashboard?.venueComplianceMap;
    }, [dashboard, isAreaManager]);

    const onLoad = useCallback((map: google.maps.Map) => {
        mapRef.current = map;
        setMapsApi(window.google.maps)
        if (complianceMap && complianceMap.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            complianceMap.forEach((item: any) => {
                const lat = parseFloat(item.latitude);
                const lng = parseFloat(item.longitude);
                if (!isNaN(lat) && !isNaN(lng)) {
                    bounds.extend({ lat, lng });
                }
            });
            map.fitBounds(bounds);
        }
    }, [complianceMap]);

    const containerStyle = {
        width: '100%',
        height: '400px'
    };

    const center = useMemo(() => {
        if (!complianceMap || complianceMap.length === 0) {
            return { lat: 0, lng: 0 }; // fallback
        }

        const total = (complianceMap.length > 0) && complianceMap?.reduce(
            (acc: any, item: any) => {
                const lat = parseFloat(item.latitude);
                const lng = parseFloat(item.longitude);
                return {
                    lat: acc.lat + lat,
                    lng: acc.lng + lng
                };
            },
            { lat: 0, lng: 0 }
        );

        return {
            lat: total.lat / complianceMap.length,
            lng: total.lng / complianceMap.length
        };
    }, [complianceMap]);

    const getMarkerIcon = (status: string) => {
        if (!mapsApi) return undefined;

        return {
            url: status == "COMPLIANT" ? greenlocation : redlocation,
            scaledSize: new mapsApi.Size(35, 50),
        };
    };

    const getBgColor = (value: string) => {
        const colors = isAreaManager
            ? dashboard?.areaComplianceRanking?.colors
            : dashboard?.venueComplianceRanking?.colors;
        switch (value) {
            case "all":
                return "var(--primary-color)";

            case "green":
                return colors?.["green"];

            case "amber":
                return colors?.["amber"];

            case "red":
                return colors?.["red"];

            default:
                return "var(--primary-color)";
        }
    };




    useEffect(() => {
        if (Regions.length > 0 && !selectedRegion) {
            setselectedRegion(Regions[0].regionId);
            setvenuelist(Regions[0].venues)
            // setvenues(Regions[0].venues[0].venueId)
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    setvenuelist(response.data);
                } catch (error: any) {
                    toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
            }

        };
        Venuelist();
    }, [selectedRegion, clientEntity])

    const fqPage = getPage('fq');
    const fqTotalPages = getTotalPages('fq', dashboard?.failedQuestions?.list, 8);
    const fqPaginatedData = getPaginatedData('fq', dashboard?.failedQuestions?.list, 8);

    const vcrPage = getPage('vcr');
    const complianceRankingList = isAreaManager
        ? dashboard?.areaComplianceRanking?.list
        : dashboard?.venueComplianceRanking?.list;
    const vcrTotalPages = getTotalPages('vcr', complianceRankingList);
    const vcrPaginatedData = getPaginatedData('vcr', complianceRankingList);

    const tdtPage = getPage('tdt');
    const tdtTotalPages = getTotalPages('tdt', todayTasklist);
    const tdtPaginatedData = getPaginatedData('tdt', todayTasklist);

    const ccPage = getPage('cc');
    const ccTotalPages = getTotalPages('cc', dashboard?.complianceByCategory, 8);
    const ccPaginatedData = getPaginatedData('cc', dashboard?.complianceByCategory, 8);

    const ciPage = getPage('ci');
    const ciTotalPages = getTotalPages('ci', dashboard?.categoryInsights?.insights, 4);
    const ciPaginatedData = getPaginatedData('ci', dashboard?.categoryInsights?.insights, 4);

    const rfPage = getPage('rf');
    const rfTotalPages = getTotalPages('rf', dashboard?.recentFails);
    const rfPaginatedData = getPaginatedData('rf', dashboard?.recentFails);


    const downloadChecklist = async (id: string | number, name: string, areaId?: string | number) => {
        const checkAreaId = areaId || storage.getItem('areaId');
        const areaIdParam = (checkListType === "AREA_MANAGER" && checkAreaId && checkAreaId !== "undefined" && checkAreaId !== "null") ? `&areaId=${checkAreaId}` : '';
        const data = `?businessCheckListSubmissionId=${id}&clientEntityId=${storage.getItem('clientEntityId')}&checkListType=${checkListType}${areaIdParam}`;

        try {
            const response = await ApiGetChecklistPdf(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (blob.size === 0) {
                throw new Error("Empty PDF file.");
            }
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${name}_${month?.month() + 1}_${month?.year()}.pdf`; // custom file name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // setPdfUrl(url); // this will trigger rendering the PDF
        } catch (error: any) {
            console.log(error)
        }
    };
    console.log("Loading", isLoading, "Time", new Date().getMilliseconds)
    if (checkListType === "AREA_MANAGER" && userRole === "areaManager") {
        return <VenueChecklistDashboard checkListType={checkListType} setCheckListType={setCheckListType} />;
    }

    return (
        <Box>
            {!isLoading && (
                <>
                    <Box className='d-flex align-items-center justify-content-between'>
                        <Typography variant='h5' className='fw-bold'>Dashboard</Typography>
                        <Box className='d-flex align-items-center gap-3 justify-content-end'>
                            {window.location.hostname.includes('aldi') && storage.getItem("userRole") === 'areaManager' && (
                                <FormControl sx={{ width: 'fit-content', minWidth: '100px' }}>
                                    {/* <InputLabel id="demo-simple-select-label" shrink={false}>Region: &nbsp;</InputLabel> */}
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        defaultValue={Regions[0]?.regionId}
                                        value={selectedRegion}
                                        onChange={(e) => { setselectedRegion(e.target.value) }}
                                    >
                                        {Regions?.map((item: any, index: number) => (
                                            <MenuItem key={index} value={item.regionId}>
                                                {item.regionName}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                            <FormControl size="small" sx={{ minWidth: "160px", bgcolor: "white" }}>
                                <InputLabel id="checklist-type-select-label">Check list view</InputLabel>
                                <Select
                                    labelId="checklist-type-select-label"
                                    id="checklist-type-select"
                                    value={checkListType}
                                    label="Check list view"
                                    onChange={(e) => {
                                        const val = e.target.value as string;
                                        setCheckListType(val);
                                        storage.setItem('dashboardCheckListType', val);
                                    }}
                                >
                                    <MenuItem value="BUSINESS">Sites</MenuItem>
                                    <MenuItem value="AREA_MANAGER">Areas</MenuItem>
                                </Select>
                            </FormControl>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker value={month}
                                    sx={{ maxWidth: "120px" }}
                                    views={['month', 'year']}
                                    format="MMM-YY"
                                    label='Month'
                                    onChange={(e: any) => {
                                        const isoString = e?.startOf('month').toISOString();
                                        dispatch(setSelectedMonth(isoString));
                                    }}
                                    slots={{
                                        openPickerIcon: ArrowDropDownIcon,
                                    }}
                                />
                            </LocalizationProvider>
                            {userRole !== 'areaManager' && (
                                <Button className='btn-main' onClick={() => { navigate('/maindashboard/Checklist/checklist-list') }}>Manage Checklist</Button>
                            )}
                        </Box>
                    </Box>
                    <Grid container className='mt-4' spacing={2}>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--primary-light-main-color)"} className={`p-3 bg-light-main2 border-10 d-flex align-items-start justify-content-between`}>
                            <Box>
                                <Box className='p-2 border-10 mb-4' sx={{ width: 'fit-content' }} bgcolor={'var(--primary-light-main-color)'}><TaskOutlined className='text-main' sx={{ fontSize: "26px" }} /></Box>
                                <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>Checklist Compliance</Typography>
                                <Typography variant='h4' className='fw-bold mb-1'>{dashboard?.overview?.totalCompliancePercentage}%</Typography>
                                <Box className='d-flex align-items-center gap-1'>{dashboard?.overview?.trend == "UP" ? <NorthOutlined className='text-main' sx={{ fontSize: '15px' }} /> : <SouthOutlined sx={{ fontSize: '15px', color: "#BF613B" }} />}<Typography variant='caption'><span className='fw-bold' style={{ fontSize: '16px' }}>{dashboard?.overview?.percentage}</span> from last month</Typography></Box>

                            </Box>

                            <Box sx={{ position: "relative", display: "inline-flex" }}>
                                {/* Background Track */}
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        color: "var(--primary-light-main-color) !important",
                                    }}
                                />

                                {/* Filled Progress */}
                                <CircularProgress
                                    variant="determinate"
                                    value={dashboard?.overview?.totalCompliancePercentage}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        color: "var(--primary-color)",
                                        "& .MuiCircularProgress-circle": {
                                            strokeLinecap: "round",
                                        },
                                    }}
                                />

                            </Box>

                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--secondary-light-color)"} border={'1px solid var(--secondary-color)'} className={`p-3  border-10 d-flex align-items-start justify-content-between`}>
                            <Box>
                                <Box className='p-2 border-10 mb-4' sx={{ width: 'fit-content' }} bgcolor={'var(--secondary-light-color)'}><WatchLaterOutlined className='text-blue' sx={{ fontSize: "26px" }} /></Box>
                                <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>Outstanding Checklists</Typography>
                                <Typography variant='h4' className='fw-bold mb-1'>{dashboard?.overview?.totalOutStandingCheckListCount}</Typography>
                                <Box className='d-flex align-items-center gap-1'><Typography variant='caption'>Across all sites</Typography></Box>

                            </Box>

                            <Box sx={{ position: "relative", display: "inline-flex" }}>
                                {/* Background Track */}
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        color: "var(--secondary-light-color) !important",
                                    }}
                                />

                                {/* Filled Progress */}
                                <CircularProgress
                                    variant="determinate"
                                    value={dashboard?.overview?.totalOutStandingPercentage}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        color: "var(--secondary-color)",
                                        "& .MuiCircularProgress-circle": {
                                            strokeLinecap: "round",
                                        },
                                    }}
                                />

                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--third-light-color)"} border={'1px solid var(--third-color) !important'} className={`p-3 ${isNotMM} border-10 d-flex align-items-start justify-content-between`}>
                            <Box>
                                <Box className='p-2 border-10 mb-4' sx={{ width: 'fit-content' }} bgcolor={'var(--third-light-color)'}><ReportProblemOutlined className='text-secondary' sx={{ fontSize: "26px" }} /></Box>
                                <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>Critical Failures</Typography>
                                <Typography variant='h4' className='fw-bold mb-1'>{dashboard?.overview?.totalFailureCheckListCount}</Typography>
                                <Box className='d-flex align-items-center gap-1'><Typography variant='caption'>Require immediate action</Typography></Box>

                            </Box>

                            <Box sx={{ position: "relative", display: "inline-flex" }}>
                                {/* Background Track */}
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        color: "var(--third-light-color) !important",
                                    }}
                                />

                                {/* Filled Progress */}
                                <CircularProgress
                                    variant="determinate"
                                    value={dashboard?.overview?.totalFailedPercentage}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        color: "var(--third-color)",
                                        "& .MuiCircularProgress-circle": {
                                            strokeLinecap: "round",
                                        },
                                    }}
                                />

                            </Box>

                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} bgcolor={"var(--primary-light-main-color)"} className={`p-3 bg-light-main2 border-10 d-flex align-items-start justify-content-between`}>
                            <Box>
                                <Box className='p-2 border-10 mb-4' sx={{ width: 'fit-content' }} bgcolor={'var(--primary-light-main-color)'}><MilitaryTechOutlined className='text-main' sx={{ fontSize: "26px" }} /></Box>
                                <Typography variant='body1' sx={{ whiteSpace: 'nowrap' }}>{isAreaManager ? "Fully Compliant Areas" : "Fully Compliant Sites"}</Typography>
                                <Box className='d-flex align-items-baseline gap-1'>
                                    <Typography variant='h4' className='fw-bold mb-1'>{isAreaManager ? dashboard?.overview?.fullyCompliantAreaCount : dashboard?.overview?.fullyCompliantVenueCount}</Typography>
                                    <Typography variant='h5' className='fw-bold mb-1' sx={{ opacity: '0.7' }}>/</Typography>
                                    <Typography variant='h5' className='fw-bold mb-1' sx={{ opacity: '0.7' }}>{isAreaManager ? dashboard?.overview?.submittedAreaCount : dashboard?.overview?.submittedVenueCount}</Typography>
                                </Box>
                                <Box className='d-flex align-items-center gap-1'><Typography variant='caption'>{isAreaManager ? dashboard?.overview?.fullyCompliantAreaPercentage : dashboard?.overview?.fullyCompliantVenuePercentage}% {isAreaManager ? "of areas" : "of sites"}</Typography></Box>
                            </Box>

                            <Box sx={{ position: "relative", display: "inline-flex" }}>
                                {/* Background Track */}
                                <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        color: "var(--primary-light-main-color) !important",
                                    }}
                                />

                                {/* Filled Progress */}
                                <CircularProgress
                                    variant="determinate"
                                    value={isAreaManager ? dashboard?.overview?.fullyCompliantAreaPercentage : dashboard?.overview?.fullyCompliantVenuePercentage}
                                    size={75}
                                    thickness={5}
                                    sx={{
                                        position: "absolute",
                                        left: 0,
                                        color: "var(--primary-color)",
                                        "& .MuiCircularProgress-circle": {
                                            strokeLinecap: "round",
                                        },
                                    }}
                                />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 7, xl: 8 }} className={`${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-start w-100 p-3 mm-card-gradient  justify-content-between'>
                                <Box className='d-flex align-items-baseline gap-2'>
                                    <Typography className='fw-bold' sx={{ whiteSpace: 'nowrap' }} variant='h6'>Checklist Compliance</Typography>
                                    {/* <Typography variant='body2'>Compliant vs failed checklists from total submitted each month</Typography> */}
                                </Box>
                                <Box className='d-flex align-items-center gap-3'>
                                    <Box className='d-flex align-items-center gap-1'>
                                        <Box height={'10px'} width={'10px'} borderRadius={'50px'} bgcolor={"var(--primary-color)"}></Box>
                                        <Typography variant='caption'>Compliant</Typography>
                                    </Box>
                                    <Box className='d-flex align-items-center gap-1'>
                                        <Box height={'10px'} width={'10px'} borderRadius={'50px'} bgcolor={"#BF613B"}></Box>
                                        <Typography variant='caption'>Failed</Typography>
                                    </Box>
                                </Box>
                            </Box>
                            <Grid container spacing={1} className='p-3'>
                                <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                                    <Typography variant='body2' gutterBottom>TOTAL SUBMITEED</Typography>
                                    <Box className='d-flex align-items-baseline gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{dashboard?.analytics?.submittedChecklist?.currentMonth}</Typography>
                                        <Typography variant='caption' className='fw-bold' sx={{ color: dashboard?.analytics?.submittedChecklist?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{dashboard?.analytics?.submittedChecklist?.trend == "UP" ? "+" : "-"} {dashboard?.analytics?.submittedChecklist?.percentage}%</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                                    <Typography variant='body2' gutterBottom>COMPLIANCE RATE</Typography>
                                    <Box className='d-flex align-items-baseline gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{dashboard?.analytics?.complianceRate?.currentMonth}%</Typography>
                                        <Typography variant='caption' className='fw-bold' sx={{ color: dashboard?.analytics?.complianceRate?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{dashboard?.analytics?.complianceRate?.trend == "UP" ? "+" : "-"} {dashboard?.analytics?.complianceRate?.percentage}%</Typography>
                                    </Box>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6, lg: 4 }} className='p-2 px-3 border-10' bgcolor={'#FFFFFF9A'}>
                                    <Typography variant='body2' gutterBottom>FAILED SUBMISSION</Typography>
                                    <Box className='d-flex align-items-baseline gap-2'>
                                        <Typography variant='h5' className='fw-bold'>{dashboard?.analytics?.failedSubmission?.currentMonth}</Typography>
                                        <Typography variant='caption' className='fw-bold' sx={{ color: dashboard?.analytics?.failedSubmission?.trend == "UP" ? "var(--primary-color)" : "#BF613B" }}>{dashboard?.analytics?.failedSubmission?.trend == "UP" ? "+" : "-"} {dashboard?.analytics?.failedSubmission?.percentage}%</Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Box maxHeight={'380px'}>
                                <ChecklistChart data={dashboard?.analytics?.lastSixMonths} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 5, xl: 4 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                                <Box>
                                    <Typography variant='h6' className='fw-bold' lineHeight={'normal'}>Top Failure Reasons</Typography>
                                    {/* <Typography variant='caption'>Across the last 6 months</Typography> */}
                                </Box>
                                <Typography variant='caption' className='px-3 py-1 border-10 fw-bold' sx={{ color: "#BF613B", backgroundColor: "#BF613B1A" }}>{dashboard?.failedQuestions?.totalQuestionsFailedCount} FAILS</Typography>
                            </Box>
                            <Box className='p-3' flex={1}>
                                {fqPaginatedData?.length > 0 ? fqPaginatedData?.map((item: any) => (
                                    <Box className='mb-3'>
                                        <Box className='d-flex align-items-center justify-content-between'>
                                            <Typography variant='body2' className='fw-bold'>{item?.questionTitle}</Typography>
                                            <Typography variant='body2'>{item?.failCount}</Typography>
                                        </Box>
                                        <LinearProgress
                                            className='mt-2'
                                            variant="determinate"
                                            value={((item?.failCount / dashboard?.failedQuestions?.totalQuestionsFailedCount) * 100) || 0}
                                            aria-label="Export data"
                                            sx={{
                                                height: 8,
                                                borderRadius: 5,
                                                backgroundColor: "#BF613B1A",
                                                "& .MuiLinearProgress-bar": {
                                                    background: "linear-gradient(90deg, #BF613B2A, #BF613B)",
                                                    borderRadius: 5,
                                                },
                                            }}
                                        />
                                    </Box>
                                )) : (
                                    <Box className='h-100 d-flex align-items-center justify-content-center'>
                                        <Typography>No Data Found</Typography>
                                    </Box>
                                )}

                                {fqTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={fqPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={fqTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("fq", value)}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, xl: 4 }} className={`${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-baseline gap-2 p-3 mm-card-gradient'>
                                <Typography className='fw-bold' variant='h6'>Compliance Trend</Typography>
                                <Typography variant='caption'>(Last 6 months)</Typography>
                            </Box>
                            <Box className='d-flex align-items-center gap-3 p-3'>
                                <Box className='d-flex align-items-center gap-1'>
                                    <Box className='bg-main' height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                                    <Typography variant='caption' className='text-dark'>Completed %</Typography>
                                </Box>
                                <Box className='d-flex align-items-center gap-1'>
                                    <Box bgcolor={'#FFBF44'} height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                                    <Typography variant='caption' className='text-dark'>Overdue %</Typography>
                                </Box>
                                <Box className='d-flex align-items-center gap-1'>
                                    <Box bgcolor={'#BF613B'} height={'8px'} width={'8px'} borderRadius={'10px'}></Box>
                                    <Typography variant='caption' className='text-dark'>Failed %</Typography>
                                </Box>
                            </Box>
                            <Box className='p-3'>
                                <MixChart data={dashboard?.analytics?.lastSixMonths} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, xl: 5 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center justify-content-between flex-wrap p-3 mm-card-gradient'>
                                <Typography className='fw-bold' variant='h6'>{isAreaManager ? "Area Compliance Ranking" : "Site Compliance Ranking"}</Typography>
                                <Box>
                                    <ToggleButtonGroup
                                        exclusive
                                        value={value}
                                        onChange={handleChange}
                                        sx={{
                                            bgcolor: "#FFFFFF",
                                            p: 0.5,
                                            borderRadius: "30px",
                                            "& .MuiToggleButton-root": {
                                                border: "none",
                                                borderRadius: "22px",
                                                textTransform: "none",
                                                px: 2.2,
                                                py: 0.8,
                                                fontWeight: 600,
                                                fontSize: 14,
                                                "&.Mui-selected": {
                                                    bgcolor: getBgColor(value),
                                                    color: "#fff",
                                                    "&:hover": {
                                                        bgcolor: getBgColor(value),
                                                    },
                                                },

                                            },
                                        }}
                                    >
                                        <ToggleButton value="all" className='m-0 py-1' sx={{
                                            color: value == "all" ? "#FFFFFF" : "#000000 !important",
                                            "&:hover": {
                                                bgcolor: `${getBgColor('all')} !important`,
                                            },
                                        }}>All</ToggleButton>
                                        <ToggleButton value="green" className='m-0 py-1' sx={{
                                            color: value == "green" ? "#FFFFFF" : `${getBgColor('green')} !important`,
                                            "&:hover": {
                                                bgcolor: `${getBgColor('green')} !important`,
                                            },
                                        }}>
                                            Green
                                        </ToggleButton>
                                        <ToggleButton value="amber" className='m-0 py-1' sx={{
                                            color: value == "amber" ? "#FFFFFF" : `${getBgColor('amber')} !important`,
                                            "&:hover": {
                                                bgcolor: `${getBgColor('amber')} !important`,
                                            },
                                        }}>
                                            Amber
                                        </ToggleButton>
                                        <ToggleButton value="red" className='m-0 py-1' sx={{
                                            color: value == "red" ? "#FFFFFF" : `${getBgColor('red')} !important`,
                                            "&:hover": {
                                                bgcolor: `${getBgColor('red')} !important`,
                                            },
                                        }}>
                                            Red
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </Box>
                            </Box>
                            <Box className='p-0 w-100 p-3' flex={1}>
                                {vcrPaginatedData?.length > 0 ?
                                    <TableContainer className='mt-3' sx={{ width: "100%" }}>
                                        <Table className='m-0 p-0' sx={{ width: "100%", tableLayout: "fixed" }}>
                                            <TableHead className='m-0 p-0'>
                                                <TableRow className='m-0 p-0'>
                                                    <TableCell className='py-1' sx={{ width: '60px !important' }}><Typography variant='caption'>#</Typography></TableCell>
                                                    <TableCell className='py-1'><Typography variant='caption'>{isAreaManager ? "AREA" : "SITE"}</Typography></TableCell>
                                                    <TableCell className='py-1 text-center'><Typography variant='caption'>COMPLIANCE</Typography></TableCell>
                                                    <TableCell className='py-1 text-center'><Typography variant='caption'>DUE TODAY</Typography></TableCell>
                                                    <TableCell className='py-1 text-center'><Typography variant='caption'>FAILURES</Typography></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    vcrPaginatedData?.filter((item: any) => value === "all" ? true : item.colorCode === getBgColor(value))?.map((item: any, index: number) => (
                                                        <TableRow className='border-0' key={index}>
                                                            <TableCell className='py-3' sx={{ width: '60px' }}><Box className='d-flex align-items-center gap-1'><Box height={'10px'} width={'10px'} borderRadius={'50%'} bgcolor={item?.colorCode}></Box><Typography variant='body2'>{index + 1}</Typography></Box></TableCell>
                                                            <TableCell className='py-3'><Typography variant='body2'>{item?.venueName || item?.areaName}</Typography></TableCell>
                                                            <TableCell className='py-3 text-center'><Typography variant='body2'>{item?.passCount}</Typography></TableCell>
                                                            <TableCell className='py-3 text-center'><Typography variant='body2'>{item?.todayDueCount}</Typography></TableCell>
                                                            <TableCell className='py-3 text-center'><Typography variant='body2'>{item?.failCount}</Typography></TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    : (
                                        <Box className='h-100 d-flex align-items-center justify-content-center'>
                                            <Typography>No Data Found</Typography>
                                        </Box>
                                    )}

                                {vcrTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={vcrPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={vcrTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("vcr", value)}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 12, md: 4, xl: 3 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                                <Typography className='fw-bold' variant='h6'>Task Due Today</Typography>
                                {/* <Typography variant='caption' className='text-main fw-bold'>View all <ArrowRightAlt /></Typography> */}
                            </Box>
                            <Box className='p-3' flex={1}>
                                {tdtPaginatedData?.length > 0 ?
                                    tdtPaginatedData?.map((item: any, index: any) => (
                                        <Box className='bg-white p-2 px-3 border-10 mb-2'>
                                            <Box className='d-flex align-items-center justify-content-between'>
                                                <Box>
                                                    <Typography variant='body1' className='fw-bold'>{item?.venueName || item?.areaName}</Typography>
                                                    <Typography variant='caption'>{item?.businessCheckListTitle}</Typography>
                                                </Box>
                                                <Box className='d-flex flex-column align-items-end'>
                                                    {/* <Typography variant='caption' className='fw-bold' color='#BF613B'>3 items</Typography> */}
                                                    <Typography variant='caption' className='fw-bold' color='#BF613B'>{dayjs(item.createdOn).fromNow()}</Typography>
                                                </Box>

                                            </Box>
                                        </Box>
                                    ))
                                    : (
                                        <Box className='h-100 d-flex align-items-center justify-content-center'>
                                            <Typography>No Data Found</Typography>
                                        </Box>
                                    )
                                }
                                {tdtTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={tdtPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={tdtTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("tdt", value)}
                                        />
                                    </Box>
                                )}

                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 8, xl: 9 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center p-3 mm-card-gradient justify-content-between'>
                                <Box className='d-flex align-items-end gap-2'>
                                    <Typography className='fw-bold' variant='h6'>Compliance by Category</Typography>
                                    <Typography variant='body2'>(Pass / fail breakdown across all sites this month)</Typography>
                                </Box>
                                {/* <Typography className='text-main px-3 py-1 border-10 fw-bold' variant='caption' bgcolor={'var(--primary-light-main-color)'}>890 CHECKS</Typography> */}
                            </Box>
                            <Box className='p-3' flex={1}>
                                {
                                    ccPaginatedData?.length > 0 ?
                                        ccPaginatedData?.map((item: any) => (
                                            <Box className='mb-3'>
                                                <Box className='d-flex align-items-center justify-content-between'>
                                                    <Typography variant='body1' className='fw-bold'>{item?.categoryName}</Typography>
                                                    <Typography variant='body2' className='text-main fw-bold'>{item?.compliancePercentage}%</Typography>
                                                </Box>
                                                <LinearProgress
                                                    className='mt-2'
                                                    variant="determinate"
                                                    value={item?.compliancePercentage || 0}
                                                    aria-label="Export data"
                                                    sx={{
                                                        height: 10,
                                                        borderRadius: 5,
                                                        backgroundColor: "#BF613B",
                                                        "& .MuiLinearProgress-bar": {
                                                            background: "var(--primary-color)",
                                                            // borderRadius: 5,
                                                        },
                                                    }}
                                                />
                                                <Box className='d-flex align-items-center gap-2 mt-1 ms-1'>
                                                    <Typography variant='caption'>{item?.passCount} passed</Typography>
                                                    <Typography variant='caption'>|</Typography>
                                                    <Typography variant='caption'>{item?.failCount} failed</Typography>
                                                    <Typography variant='caption'>|</Typography>
                                                    <Typography variant='caption'>{item?.totalCount} total</Typography>
                                                </Box>
                                            </Box>

                                        ))
                                        :
                                        (
                                            <Box className='h-100 d-flex align-items-center justify-content-center'>
                                                <Typography>No Data Found</Typography>
                                            </Box>
                                        )
                                }

                                {ccTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={ccPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={ccTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("cc", value)}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, xl: 3 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='p-3 mm-card-gradient d-flex align-items-end gap-2'>
                                <Typography className='fw-bold' variant='h6'>Category Insights</Typography>
                                <Typography className='fw-bold' variant='body2'>(High-impact observations this month)</Typography>
                            </Box>
                            <Box className='p-3 h-100 d-flex flex-column'>
                                <Box flex={1}>
                                    {ciPaginatedData?.length > 0 ?
                                        ciPaginatedData?.map((item: any) => (
                                            <Box className='p-3 border-10 mb-2' border={item?.type === "warning" ? '1px solid #BF613B' : item?.type === "positive" ? "1px solid var(--primary-color)" : "1px solid var(--secondary-color)"} bgcolor={item?.type === "warning" ? '#BF613B1A' : item?.type === "positive" ? "var(--primary-light-main-color)" : "var(--secondary-light-color)"}>
                                                <Typography variant='body1' className='fw-bold'>{item?.title} ({item?.categoryName})</Typography>
                                                <Typography variant='body2'>{item?.description}</Typography>
                                            </Box>
                                        ))
                                        :
                                        (
                                            <Box className='h-100 d-flex align-items-center justify-content-center'>
                                                <Typography>No Data Found</Typography>
                                            </Box>
                                        )

                                    }
                                </Box>
                                {dashboard?.categoryInsights?.tip && (
                                    <Box className='p-3 mt-3 border-10' border={'1px solid var(--primary-color)'} bgcolor={'var(--primary-light-main-color)'}>
                                        <Typography><b className='text-main'>Tip: </b>{dashboard?.categoryInsights?.tip}</Typography>
                                    </Box>
                                )}

                                {ciTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={ciPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={ciTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("ci", value)}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        <Grid size={{ xs: 12, md: 6, xl: 3 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                                <Typography className='fw-bold' variant='h6'>Recent Fails</Typography>
                                {/* <Typography variant='caption' className='text-main fw-bold'>View all <ArrowRightAlt /></Typography> */}
                            </Box>
                            <Box className='p-3' flex={1}>
                                {rfPaginatedData?.length > 0 ?
                                    rfPaginatedData?.map((item: any) => (
                                        <Box className='bg-white p-3 border-10 border-bottom mb-2'>
                                            <Box className='d-flex align-items-center justify-content-between'>
                                                <Box>
                                                    <Typography variant='body1' className='fw-bold'>{item?.venueName || item?.areaName}</Typography>
                                                    {/* <Typography variant='body2'>Freezer temperature above safe range</Typography> */}
                                                </Box>
                                                <Box className='d-flex flex-column align-items-end'>
                                                    {/* <Typography variant='caption' className='fw-bold' color='#BF613B'>3 items</Typography> */}
                                                    <Typography variant='caption' className='fw-bold' color='#BF613B'>{dayjs(item.failedOn).fromNow()}</Typography>
                                                </Box>

                                            </Box>
                                        </Box>
                                    ))
                                    :
                                    (
                                        <Box className='h-100 d-flex align-items-center justify-content-center'>
                                            <Typography>No Data Found</Typography>
                                        </Box>
                                    )
                                }

                                {rfTotalPages > 1 && (
                                    <Box display="flex" justifyContent="center" mt={2}>
                                        <Pagination
                                            page={rfPage}
                                            sx={{
                                                "& .MuiPaginationItem-root.Mui-selected": {
                                                    backgroundColor: 'var(--primary-color)'
                                                }
                                            }}
                                            count={rfTotalPages}
                                            color="primary"
                                            onChange={(_, value) => setPage2("rf", value)}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>

                        {!isAreaManager && (
                            <Grid size={{ xs: 12, md: 12, xl: 9 }} className={`${isNotMM} border-10 overflow-hidden`}>
                                <Typography className='fw-bold p-3 mm-card-gradient' variant='h6'>{isAreaManager ? "Area Compliance Map" : "Site Compliance Map"}</Typography>
                                <Box className='p-3'>
                                    {complianceMap?.length > 0 ?
                                        (<LoadScript googleMapsApiKey="AIzaSyCmcI0swO1MNjQYUD7qktNT78-cDMBoi44">
                                            <GoogleMap
                                                key={dashboard}
                                                onLoad={onLoad}
                                                onClick={() => setSelectedMarker(null)}
                                                mapContainerStyle={containerStyle} center={center} zoom={4}>
                                                {(complianceMap && (complianceMap?.length) > 0) && complianceMap?.map((item: any, index: number) => {
                                                    const lat = parseFloat(item.latitude);
                                                    const lng = parseFloat(item.longitude);
                                                    if (isNaN(lat) || isNaN(lng)) return null;
                                                    return (
                                                        <Marker
                                                            key={index}
                                                            position={{ lat, lng }}
                                                            onClick={() => setSelectedMarker(item)}
                                                            icon={getMarkerIcon(item.status)}
                                                        />
                                                    );
                                                })}

                                                {selectedMarker && selectedMarker.latitude && selectedMarker.longitude && (
                                                    <InfoWindow
                                                        position={{
                                                            lat: parseFloat(selectedMarker.latitude),
                                                            lng: parseFloat(selectedMarker.longitude)
                                                         }}
                                                        onCloseClick={() => setSelectedMarker(null)}
                                                    >
                                                        <div className='m-0 p-0'>
                                                            <p className='m-0 p-0'>{selectedMarker.venueName || selectedMarker.areaName || "No Name"}</p>
                                                        </div>
                                                    </InfoWindow>
                                                )}
                                            </GoogleMap>
                                        </LoadScript>)
                                        :
                                        (
                                            <Box className='d-flex align-items-center justify-content-center'>
                                                <Typography>No Data Found</Typography>
                                            </Box>
                                        )}
                                </Box>
                            </Grid>
                        )}

                        <Grid size={{ xs: 12 }} className={`d-flex flex-column ${isNotMM} border-10 overflow-hidden`}>
                            <Box className='d-flex align-items-center justify-content-between p-3 mm-card-gradient'>
                                <Box>
                                    <Typography className='fw-bold' variant='h6'>{isAreaManager ? "Area Checklists" : "Site Checklists"}</Typography>
                                    <Typography className='fw-bold' variant='body2'>Open any completed checklist to review answers, notes, and photos.</Typography>
                                </Box>
                                <Link to={'/maindashboard/checklist/checklist-submitted-list'} className='text-main fw-bold'>View All</Link>
                            </Box>
                            <Box className='border-10' flex={1} bgcolor={submittedChecklist?.length > 0 ? "#FFFFFF" : ""}>
                                {submittedChecklist?.length > 0 ? submittedChecklist?.map((item: any, index: number) => (
                                    // <Box className='d-flex align-items-center p-3 justify-content-between border-bottom' key={index}>
                                    //     <Box>
                                    //         <Typography variant='body1' maxWidth={'200px'} className='fw-bold' lineHeight={'normal'}>{item?.businessCheckListTitle}</Typography>
                                    //         <Typography variant='body2'>{item?.venueName}</Typography>
                                    //     </Box>
                                    //     <Typography variant='body2'>{dayjs(item?.submittedOn).fromNow()}</Typography>
                                    //     <Typography variant='body2'>{item?.userName}</Typography>
                                    //     <Box className='d-flex align-items-center gap-2'>
                                    //         <Typography variant='caption' className='px-2 border-10 fw-bold' sx={{ color: item?.resultStatus === "PASS" ? "var(--primary-color)" : "#BF613B" }} bgcolor={item?.resultStatus === "PASS" ? 'var(--primary-light-main-color)' : "#BF613B2A"}>{item?.resultStatus}</Typography>
                                    //         <Typography variant='caption'>{item?.attachedImageCount} photos</Typography>
                                    //     </Box>
                                    //     <Tooltip title='View Checklist'>
                                    //         <IconButton onClick={() => { navigate(`/maindashboard/checklist/checklist-list/checklist-questions/${item?.businessCheckListSubmissionId}`) }} className='m-0 p-0'>
                                    //             <VisibilityOutlined />
                                    //         </IconButton>
                                    //     </Tooltip>
                                    //     <Tooltip title='Download pdf'>
                                    //         <IconButton onClick={() => { downloadChecklist(item?.businessCheckListSubmissionId, item?.businessCheckListTitle) }} className='m-0 p-0'>
                                    //             <Download className='text-main' />
                                    //         </IconButton>
                                    //     </Tooltip>
                                    // </Box>
                                    <Grid container spacing={2} className='p-3 border-bottom w-100 align-items-center justify-content-between' key={index}>
                                        <Grid size={4}>
                                            <Box>
                                                <Typography variant='body1' className='fw-bold' lineHeight={'normal'}>{item?.businessCheckListTitle}</Typography>
                                                <Typography variant='body2'>{item?.venueName || item?.areaName}</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size={2}>
                                            <Typography variant='body2' className='text-center'>{dayjs(item?.submittedOn).fromNow()}</Typography>
                                        </Grid>
                                        <Grid size={2}>
                                            <Typography variant='body2' className='text-center'>{item?.userName}</Typography>
                                        </Grid>
                                        <Grid size={2}>
                                            <Box className='d-flex align-items-center justify-content-center gap-2'>
                                                <Typography variant='caption' className='px-2 border-10 fw-bold' sx={{ color: item?.resultStatus === "PASS" ? "var(--primary-color)" : "#BF613B" }} bgcolor={item?.resultStatus === "PASS" ? 'var(--primary-light-main-color)' : "#BF613B2A"}>{item?.resultStatus}</Typography>
                                                <Typography variant='caption'>{item?.attachedImageCount} photos</Typography>
                                            </Box>
                                        </Grid>
                                        <Grid size={2} className='d-flex  align-items-center justify-content-center gap-2'>
                                            <Tooltip title='View Checklist'>
                                                <IconButton onClick={() => { navigate(`/maindashboard/checklist/checklist-list/checklist-questions/${item?.businessCheckListSubmissionId}`) }} className='m-0 p-0'>
                                                    <VisibilityOutlined />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title='Download pdf'>
                                                <IconButton onClick={() => { downloadChecklist(item?.businessCheckListSubmissionId, item?.businessCheckListTitle, item?.areaId) }} className='m-0 p-0'>
                                                    <Download className='text-main' />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                ))
                                    :
                                    (
                                        <Box className='h-100 d-flex align-items-center justify-content-center'>
                                            <Typography>No Data Found</Typography>
                                        </Box>
                                    )
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </>
            )}
            {isLoading && (
                <Box
                    position={'absolute'}
                    top={0}
                    left={0}
                    height={'100%'}
                    width={'100%'}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    py={3}
                    sx={{
                        pointerEvents: "all",
                        cursor: "wait"
                    }}
                >
                    <CircularProgress sx={{ color: 'var(--primary-color)', borderWidth: '2px' }} />
                </Box>
            )}
        </Box>
    )
}

export default ClientChecklistDashboard
